import type { ReactNode } from 'react';
import type { PopoverItemBaseProps } from '../../Popover/PopoverItem/PopoverItem';
import type { TopbarActionButtonProps } from './base/TopbarActionButton';

import { useTranslation } from 'react-i18next';

import { TrashSolidIcon } from '../../../images/shapes';

import TopbarActionButton from './base/TopbarActionButton';

interface TopbarDeleteButtonProps extends PopoverItemBaseProps {
  /**
   * On delete click
   */
  onClick: () => void;
  /**
   * Button label, default "Delete"
   */
  label?: ReactNode;
}

const TopbarDeleteButton = ({
  onClick,
  label,
  ...props
}: TopbarDeleteButtonProps & TopbarActionButtonProps) => {
  const { t } = useTranslation();

  return (
    <TopbarActionButton
      onClick={onClick}
      color="red"
      label={label || t('Global.Delete')}
      iconImage={<TrashSolidIcon className="w-3 mb-px" />}
      additionalIconClasses="ml-0.5 mr-3"
      testIdSuffix="delete"
      {...props}
    />
  );
};

export default TopbarDeleteButton;
